'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = require('recompose');

var _browser = require('../../utils/services/browser');

var _Icon = require('../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _elementResizeHandleMouseDecorator = require('./elementResizeHandleMouseDecorator');

var _elementResizeHandleMouseDecorator2 = _interopRequireDefault(_elementResizeHandleMouseDecorator);

var _elementResizeHandleTouchDecorator = require('./elementResizeHandleTouchDecorator');

var _elementResizeHandleTouchDecorator2 = _interopRequireDefault(_elementResizeHandleTouchDecorator);

require('./ElementResizeHandle.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
var ElementResizeHandle = function ElementResizeHandle(props) {
    var onMouseDown = props.onMouseDown,
        onTouchStart = props.onTouchStart,
        onDoubleClick = props.onDoubleClick,
        inList = props.inList,
        showHandle = props.showHandle;


    if (inList || !showHandle) {
        return null;
    }

    return _react2.default.createElement(
        'div',
        { className: 'ElementResizeHandle',
            onMouseDown: onMouseDown,
            onTouchStart: onTouchStart,
            onDoubleClick: onDoubleClick },
        _react2.default.createElement(_Icon2.default, { name: 'element-resize-handle' })
    );
};

// Styles


ElementResizeHandle.propTypes = {
    element: _propTypes2.default.object,
    gridSize: _propTypes2.default.number,
    inList: _propTypes2.default.string,
    showHandle: _propTypes2.default.bool,
    onMouseDown: _propTypes2.default.func,
    onTouchStart: _propTypes2.default.func,
    onDoubleClick: _propTypes2.default.func
};

exports.default = (0, _recompose.branch)(_browser.isMobile, _elementResizeHandleTouchDecorator2.default, _elementResizeHandleMouseDecorator2.default)(ElementResizeHandle);


//////////////////
// WEBPACK FOOTER
// ./src/client/element/resizing/ElementResizeHandle.js
// module id = 741
// module chunks = 0